import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CardTitle, CardTitleContainer, CardsContainer } from '../sections.style'
import Spinner from 'parkdepot-shared/components/Spinner'
import BookingCard from '@components/BookingCard/BookingCard.component'
import useBookings from '@hooks/useBookings.hook'
import useSubscriptions from '@hooks/useSubscriptions.hook'

interface Props {
    showPastBookings?: boolean
}

const BookingSection: FC<Props> = ({ showPastBookings = false }) => {
    const { t } = useTranslation()

    const { groupBookingsByStatus, loading } = useBookings()
    const bookings = showPastBookings
        ? groupBookingsByStatus().completedBookings
        : [...groupBookingsByStatus().activeBookings, ...groupBookingsByStatus().futureBookings]

    const { groupSubscriptionsByStatus, loading: subLoading } = useSubscriptions()
    const subscriptions = showPastBookings
        ? [...groupSubscriptionsByStatus().completedSubscriptions]
        : [...groupSubscriptionsByStatus().activeSubscriptions, ...groupSubscriptionsByStatus().futureSubscriptions]

    return (
        <div>
            {!showPastBookings && (
                <CardTitleContainer>
                    <CardTitle>{t('home.reservation')}</CardTitle>
                    {loading || subLoading ? <Spinner /> : null}
                </CardTitleContainer>
            )}
            <CardsContainer>
                <>
                    {bookings &&
                        bookings.length > 0 &&
                        bookings.map((booking) => (
                            <BookingCard
                                key={booking.booking_ref}
                                type="booking"
                                booking={booking}
                                lotName={booking.lot_name}
                                startDate={booking.start_date}
                                endDate={booking.end_date}
                                plates={booking.plates?.map((lp) => lp.plate) ?? []}
                            />
                        ))}
                    {subscriptions &&
                        subscriptions.length > 0 &&
                        subscriptions.map((sub) => (
                            <BookingCard
                                key={sub.id}
                                type="subscription"
                                subscription={sub}
                                lotName={sub.lot_name}
                                startDate={sub.start_date}
                                endDate={sub.end_date}
                                plates={sub.plates?.map((lp) => lp) ?? []}
                            />
                        ))}
                </>
            </CardsContainer>
        </div>
    )
}

export default BookingSection
